import axios from 'axios'
import { Category } from '../models/category.model';
import { BaseService } from './base.service';

class CategoryService extends BaseService{

    constructor() {
        super();
        console.log("created a instance of CategoryService");
    }

    async delete(id: number){
        let result = await axios.delete(`${this.api}category/DeleteCategory?id=${id}`);
        return result;
        // return this.execute('delete', `category/${id}`);
    }

    async getAll(companyId:string){
        return axios.get(`${this.api}category/GetCategoryList?companyId=${companyId}`).then(req => { return req.data });
        // return this.execute('get', 'category/');
    }

    
    async getAllKeyValue(companyId:string){
        return axios.get(`${this.api}category/GetCategoryKeyValueList?companyId=${companyId}`).then(req => { return req.data });
        // return this.execute('get', 'category/');
    }

    async getCount(){
        return axios.get(`${this.api}category/count`).then(req => { return req.data });
    }

    async get(id: number){
        return axios.get(`${this.api}category/GetCategory?id=${id}`).then(req => { return req.data });
        // return this.execute('get', `category/${id}`);
    }

    async create(category: Category){
        let result = await axios.post(`${this.api}category/CreateCategory`, category);
        return result;
        // return this.execute('post', `category/`, category);
    }

    async update(category: Category){
        let result = await axios.put(`${this.api}category/UpdateCategory`, category);
        return result;
        // return this.execute('put', `category/${category.id}`, category);
    }
}

export const categoryService = new CategoryService();

